export default {
  Driver: 1,
  Resale: 2
}
